export const iconFontAwesomeAnimalsFeather = (
	<i className="fa-solid fa-feather"></i>
);
